import React from "react";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import FileBase64 from 'react-file-base64';

import Button from './Button';
import TextInput from './TextInput';
import getSetting from "../services/getSetting";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import Cookies from "universal-cookie";
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class SendMailWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            sendMailKey: Math.random(),
            editorState: EditorState.createEmpty(),
            subject: '', 
            warningShowed: false,
        }
    }

    async componentDidMount() {
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.mail = await getSetting(username, token, 'sendingMailAddress');
        this.mailPassword = await getSetting(username, token, 'sendingMailPassword');
    }

    componentDidUpdate() {
        if (this.props.show && !this.state.warningShowed) {
            
            if (this.mail === '' ||  this.mailPassword === '') {
                Utils.showError(t('no_mail_info'));
                this.setState({ warningShowed: true });
            }
        }
    }

    reset (){
        this.setState({
            sendMailKey: Math.random(),
            editorState: EditorState.createEmpty(),
            subject: ''
        });
    }

    onContentStateChange = contentState => {
        this.savedEnabled = true;
        this.setState({ contentState});
    }

    render() {

        return ( 
        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.props.onClose(); this.setState({ warningShowed: false }); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                <div style={closeBtn} onClick={() => {
                    this.props.onClose();
                    this.setState({ warningShowed: false });
                }}>
                    <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                </div>
                <div style={windowTitle}>{t('invia_email')}</div>
                <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: -5 }}>
                    <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                    <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('invia_mail_info')}</p><br/>
                </div>
                <div>{t('oggetto')}:</div>
                <TextInput name={''} value={this.state.subject} 
                    onChange={(text) => { this.setState({subject: text})}
                } />
                <br/>
                <div>{t('testo')}</div>
                <div style={bodyMsg}>
                    <Editor
                            editorState={this.state.editorState}
                            onContentStateChange={this.onContentStateChange}
                            onEditorStateChange={(editorState) => {
                                this.setState({
                                editorState
                                });
                            }}
                            toolbarClassName="demo-toolbar-custom"
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor-custom"
                            toolbar={{
                                options: ['inline', 'fontSize', 'fontFamily', 'colorPicker'],       
                                inline: {
                                    options: ['bold', 'italic', 'underline'],
                                    bold: { className: 'bordered-option-classname' },
                                    italic: { className: 'bordered-option-classname' },
                                    underline: { className: 'bordered-option-classname' },
                                },
                            }}
                        />
                </div>
                <br/>


                <FileBase64 key={this.state.sendMailKey}
                    multiple={ false }                    
                    onDone={ (files) => {
                        this.setState({
                            files: files
                        });
                      }} />

                {this.state.files ? <div styl={{cursor: 'pointer'}} onClick={() => {
                    this.setState({
                        files: undefined,
                        sendMailKey: Math.random()
                    });
                    }
                }> {t('elimina_allegato')}</div> : null}

                <br/>
                <br/>

                <Button callback={() => {
                    var body = draftToHtml(this.state.contentState);
                    if (this.state.subject == "" || this.state.subject == undefined){
                        alert ('Check the subject');
                        return;
                    }

                    this.props.onSend(this.state.subject, body, this.state.files);
                }} title={t('invia')}></Button>
            </div>
            </div>
        </div>
        )
    }


}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    position: 'absolute',
    top: '100px',
    left: '25%', 
    width: '50%',
    height: '560px',
    background: 'white',
    padding: '2%', 
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const bodyMsg = {
    border: '1px solid black',
    height: '200px'
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}